// extracted by mini-css-extract-plugin
export default {"title":"S4Lhgg9_j_btwrEBtlBJ"};